import * as React from 'react';
export const IcEndocrinology = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.06 4c-1.3-.02-2.51.55-3.33 1.49-.5.58-.79 1.32-.92 2.08l-.65 3.54c-.09.52-.55.89-1.07.89-.6 0-1.09-.49-1.09-1.09V9c0-.55-.45-1-1-1s-1 .45-1 1v1.91c0 .6-.49 1.09-1.09 1.09-.53 0-.98-.38-1.07-.89l-.65-3.54c-.14-.76-.42-1.5-.92-2.08A4.338 4.338 0 003.94 4C2.86 4.02 2 4.92 2 6v12c0 1.08.87 1.99 1.95 2 1.86.02 3.56-1.02 4.39-2.68.4-.81 1.23-1.32 2.13-1.32h3.06c.9 0 1.73.51 2.13 1.32.83 1.66 2.53 2.7 4.39 2.68 1.08-.01 1.95-.92 1.95-2V6c0-1.08-.86-1.98-1.94-2z'
      fill='currentColor'
    />
  </svg>
);
